// src/pages/admin/components/GroupManagement/GroupDetails.js
import React, { useEffect } from 'react';
import GroupAssignments from './GroupAssignments';

const GroupDetails = ({
  selectedGroup,
  newGroupName,
  setNewGroupName,
  selectedMentorIds,
  setSelectedMentorIds,
  allMentors,
  onSave,
  onDelete
}) => {
  useEffect(() => {
    if (selectedGroup) setNewGroupName(selectedGroup.name);
  }, [selectedGroup, setNewGroupName]);

  if (!selectedGroup) {
    return (
      <div className="group-details empty-state">
        <p>Select a group to view details or create a new one.</p>
      </div>
    );
  }

  const isNewGroup = selectedGroup.id === 'new' || !selectedGroup.id;

  const toggleMentor = (mentorId) => {
    setSelectedMentorIds(prev =>
      prev.includes(mentorId) ? prev.filter(id => id !== mentorId) : [...prev, mentorId]
    );
  };

  return (
    <div className="group-details">
      <div className="group-header">
        <div className="group-name-field">
          <input type="text" value={newGroupName} onChange={(e) => setNewGroupName(e.target.value)}
            className="group-name-input" placeholder="Enter group name" />
        </div>
        <div className="group-actions">
          <button className="save-button" onClick={onSave}>
            {isNewGroup ? 'Create Group' : 'Save Group'}
          </button>
          {!isNewGroup && (
            <button className="delete-button" onClick={onDelete}>Delete Group</button>
          )}
        </div>
      </div>

      {/* Mentor checklist */}
      <div className="group-members" style={{ marginTop: '20px' }}>
        <strong>Mentors ({selectedMentorIds.length}):</strong>
        {allMentors.length > 0 ? (
          <div style={{ marginTop: '8px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
            {allMentors.map(mentor => (
              <label key={mentor.id} style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                <input
                  type="checkbox"
                  checked={selectedMentorIds.includes(mentor.id)}
                  onChange={() => toggleMentor(mentor.id)}
                />
                <span>{mentor.name}</span>
                <span style={{ color: '#999', fontSize: '13px' }}>{mentor.email}</span>
              </label>
            ))}
          </div>
        ) : (
          <p style={{ color: '#999', marginTop: '6px' }}>No mentors available.</p>
        )}
      </div>

      {/* Learner list — display only, assigned via Users tab */}
      {!isNewGroup && (
        <div className="group-members" style={{ marginTop: '20px' }}>
          <strong>Learners ({selectedGroup.learners?.length || 0}):</strong>
          {selectedGroup.learners?.length > 0 ? (
            <ul style={{ margin: '8px 0 0 0', paddingLeft: '20px' }}>
              {selectedGroup.learners.map(learner => (
                <li key={learner.id} style={{ padding: '3px 0', color: '#333' }}>
                  {learner.name}
                  <span style={{ color: '#999', fontSize: '13px', marginLeft: '8px' }}>{learner.email}</span>
                </li>
              ))}
            </ul>
          ) : (
            <p style={{ color: '#999', marginTop: '6px' }}>No learners assigned yet. Assign via the Users tab.</p>
          )}
        </div>
      )}

      {!isNewGroup && (
        <>
          <div className="group-tabs" style={{ marginTop: '24px' }}>
            <button className="tab-button active" disabled>Assignments</button>
          </div>
          <GroupAssignments group={selectedGroup} isEditing={true} />
        </>
      )}

      {isNewGroup && (
        <div style={{ padding: '20px', backgroundColor: '#f8f9fa', borderRadius: '8px', marginTop: '20px', textAlign: 'center' }}>
          <p>Save the group first to manage assignments.</p>
          <p style={{ fontSize: '14px', color: '#6c757d' }}>Assign learners via the Users tab.</p>
        </div>
      )}
    </div>
  );
};

export default GroupDetails;